Drupal.behaviors.mainMenu = {
  attach(context) {
    const menuResponsive = context.getElementsByClassName(
      'menu--simple-mega-menu--responsive',
    )[0];
    if (menuResponsive) {
      const megaMenu = context.getElementsByClassName('mega-menu--responsive');
      const toggleExpandResponsive = megaMenu[0].getElementsByClassName(
        'toggle-expand',
      )[0];
      const utilityMenu = context.getElementsByClassName(
        'inline-menu--menu-account',
      )[0];

      // Clone the utility menu into menuResponsive.
      if (utilityMenu) {
        const utilityMenuClone = utilityMenu.cloneNode(true);
        menuResponsive.lastChild.after(utilityMenuClone);
      }

      // Mobile Menu Show/Hide.
      toggleExpandResponsive.addEventListener('click', (e) => {
        toggleExpandResponsive.classList.toggle('toggle-expand--open');
        menuResponsive.classList.toggle(
          'menu--simple-mega-menu--responsive--open',
        );
        context.body.classList.toggle('stop-scrolling');
        e.preventDefault();
      });
    }

    // const toggleExpand = context.getElementById('toggle-expand');
    // const menu = context.getElementById('main-nav');
    // if (menu) {
    //   const expandMenu = menu.getElementsByClassName('expand-sub');
    //
    //   // Mobile Menu Show/Hide.
    //   toggleExpand.addEventListener('click', (e) => {
    //     toggleExpand.classList.toggle('toggle-expand--open');
    //     menu.classList.toggle('main-nav--open');
    //     e.preventDefault();
    //   });
    //
    //   // Expose mobile sub menu on click.
    //   Array.from(expandMenu).forEach((item) => {
    //     item.addEventListener('click', (e) => {
    //       const menuItem = e.currentTarget;
    //       const subMenu = menuItem.nextElementSibling;
    //
    //       menuItem.classList.toggle('expand-sub--open');
    //       subMenu.classList.toggle('main-menu--sub-open');
    //     });
    //   });
    // }
  },
};
